import React, { useContext } from "react";
import uprightarrow from "../images/uprightarrow.png";
import jobdeschero from "../images/jobdeschero.jpg";
import applicationform from "../images/ApplicationForm.pdf";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { SectionsContext } from "../store/section-context";

function Jobdesc() {
  const { careers } = useContext(SectionsContext);

  const { jobId } = useParams();
  let { state } = useLocation();

  if (!state) state = careers.jobOpenings[Number(jobId)];

  if (!state) {
    return <Navigate to="/job" />;
  }

  const {
    title,
    location,
    summary,
    responsibilities,
    requirements,
    benefits,
    equalOpportunities,
    disability,
  } = state;

  return (
    <div className="">
      {/* <div>
        <div className="">
          <img
            src={jobdeschero}
            className="d-block w-100 aboutheroimg"
            alt="An aged woman experiencing peace of mind."
          />
          <div className="carousel-caption d-block">
            <div className="lhs lhsmobile">
              <div className="lhsheading">
                {" "}
                <span className="thick-dot"></span>{" "}
                <span className="ps-1">
                  {" "}
                  JOIN OUR TEAM AT BROOKS HEALTH AND CARE{" "}
                </span>{" "}
              </div>
              <div className="lhssubtitle pt-3">
                Explore Exciting Career Opportunities with Brooks{" "}
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div
        className="aboutheroreplacement p-md-5 p-4"
        style={{
          backgroundImage: `url(${jobdeschero})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
          backgroundColor: "rgb(0 0 0 / 70%)",
        }}
      >
        <div className="aboutheroreplacementbox">
          <div className="lhsheading">
            {" "}
            <span className="thick-dot"></span>{" "}
            <span className="ps-1">
              JOIN OUR TEAM AT BROOKS HEALTH AND CARE{" "}
            </span>{" "}
          </div>
          <div className="lhssubtitle pt-3 pb-1">
            Explore Exciting Career Opportunities with Brooks{" "}
          </div>
        </div>
      </div>
      <div className="px-md-5 px-4 pt-5 pb-1">
        <div className="jobdescsegment1">
          <div className="backbutton">
            <a href="/job" style={{ color: "black" }}>
              <i className="fa-solid fa-arrow-left-long pe-1"></i> BACK
            </a>
          </div>
          <div className="jobdescsegment1subtitle pt-4">
            <div>Job Title: {title}</div>
            <div className="fs-4 pt-1">Location: {location}</div>
          </div>
        </div>
      </div>
      <div className="horizontal-border-line pt-3"></div>
      <div className="greybg">
        <div className="jobdescsegment2 p-4  p-md-5">
          <div className="jobdescsegment2heading "> Job Summary</div>
          <div
            className="jobdescsegment2list pt-2"
            dangerouslySetInnerHTML={{ __html: summary }}
          ></div>
          <div className="jobdescsegment2heading pt-4">
            Key Responsibilities
          </div>
          <div className="jobdescsegment2list pt-2">
            <ol>
              {responsibilities.map((res, index) => (
                <li key={index}> {res}</li>
              ))}
              \
            </ol>
          </div>
          <div className="jobdescsegment2heading pt-3">Requirements</div>
          <div className="jobdescsegment2list pt-2">
            <ol>
              {requirements.map((res, index) => (
                <li key={index}> {res}</li>
              ))}
            </ol>
          </div>
          <div className="jobdescsegment2heading pt-3">Benefits</div>
          <div className="jobdescsegment2list pt-2">
            <ol>
              {benefits.map((res, index) => (
                <li key={index}> {res}</li>
              ))}
            </ol>
          </div>
          <div className="jobdescsegment2heading pt-3">
            {" "}
            Equal Opportunities
          </div>
          <div className="jobdescsegment2list pt-2">{equalOpportunities}</div>
          <div className="jobdescsegment2heading pt-3">Disability</div>
          <div className="jobdescsegment2list pt-2">{disability}</div>
        </div>
      </div>
      {/* <div className="greyb">
        <div className="px-4 px-md-5 ">
          <div className="jobdescsegment1">
            <div className="jobdescsegment1subtitle pt-2">
              <div>Job Title: Support Worker</div>
            </div>
          </div>
        </div>
        <div className="jobdescsegment2  py-4 px-4 px-md-5">
          <div className="jobdescsegment2heading ">Skills and Knowledge</div>
          <div className="jobdescsegment2list pt-2">
            <ol>
              <li>
                Ability to demonstrate a warm, person centred and affirmative
                approach to people with learning disabilities, autistic spectrum
                disorders, mental health needs-
                <div>
                  <span className="bluetext">Assessed by Interview,</span>{" "}
                  <span className="blacktext">Requirement -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                Good verbal communication skills and ability to listen
                sensitively to others
                <div>
                  <span className="bluetext">Assessed by Interview,</span>{" "}
                  <span className="blacktext">Requirement -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                Ability to engage with service users, to develop and sustain
                warm and trusting relationships
                <div>
                  <span className="bluetext">Assessed by Interview,</span>{" "}
                  <span className="blacktext">Requirement -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                Ability to demonstrate basic insight and understanding into the
                needs of people with learning disabilities, autistic spectrum
                disorders, mental health needs.
                <div>
                  <span className="bluetext">Assessed by Interview,</span>{" "}
                  <span className="blacktext">Requirement -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                Written communication skills, sufficient to contribute to a
                record keeping system
                <div>
                  <span className="bluetext">
                    Assessed by Application Form and Interview,
                  </span>{" "}
                  <span className="blacktext">Requirement -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                Ability to work constructively and co-operatively as part of a
                team
                <div>
                  <span className="bluetext">Assessed by Interview,</span>{" "}
                  <span className="blacktext">Requirement -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                Ability to work safely and responsibly without direct
                supervision in service user’s own homes
                <div>
                  <span className="bluetext">Assessed by Interview,</span>{" "}
                  <span className="blacktext">Requirement -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                Ability to demonstrate initiative, self motivation and
                resourcefulness
                <div>
                  <span className="bluetext">Assessed by Interview,</span>{" "}
                  <span className="blacktext">Requirement -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                Ability to liaise in a professional manner with other agencies
                and to work in a positive way with the families and friends of
                service users
                <div>
                  <span className="bluetext">Assessed by Interview,</span>{" "}
                  <span className="blacktext">Requirement -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>

              <li>
                {" "}
                Understanding of the person centered aims and principles of
                Creative Support and ability to put these into practice
                <div>
                  <span className="bluetext">
                    Assessed by Application Form and Interview,
                  </span>{" "}
                  <span className="blacktext">Requirement -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                Ability to demonstrate respect for difference and diversity
                <div>
                  <span className="bluetext">
                    Assessed by Application Form and Interview,
                  </span>{" "}
                  <span className="blacktext">Requirement -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                Ability to provide emotional and practical support to service
                users
                <div>
                  <span className="bluetext">
                    Assessed by Application Form and Interview,
                  </span>{" "}
                  <span className="blacktext">Requirement -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                A non judgmental, accepting approach to working with people who
                may be challenging and the ability to cope in a mature way with
                conflict, distress and challenging behavior
                <div>
                  <span className="bluetext">Assessed by Interview,</span>{" "}
                  <span className="blacktext">Requirement -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                Ability to work in a calm, patient and tolerant manner at a pace
                appropriate to the needs of the individual
                <div>
                  <span className="bluetext">Assessed by Interview,</span>{" "}
                  <span className="blacktext">Requirement -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                Ability to enable people to enjoy developmental opportunities
                without being exposed to unacceptable risks
                <div>
                  <span className="bluetext">Assessed by Interview,</span>{" "}
                  <span className="blacktext">Requirement -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>
            </ol>
          </div>
          <div className="jobdescsegment2heading pt-3">
            Experience and Qualifications
          </div>
          <div className="jobdescsegment2list pt-2">
            <ol>
              <li>
                {" "}
                Experience of providing care, support or other services to
                people with support
                <div>
                  <span className="bluetext">
                    Assessed by Application Form and Interview,
                  </span>{" "}
                  <span className="blacktext">Needs -</span>{" "}
                  <span className="bluetext">Desirable</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                Experience of supporting people with learning disabilities,
                autistic spectrum disorders, mental health needs
                <div>
                  <span className="bluetext">
                    Assessed by Application Form,
                  </span>{" "}
                  <span className="blacktext">Needs -</span>{" "}
                  <span className="bluetext">Desirable</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                Life experience and confidence in relating to people from a wide
                variety of backgrounds
                <div>
                  <span className="bluetext">
                    Assessed by Application Form and Interview,
                  </span>{" "}
                  <span className="blacktext">Needs -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                Possession of NVQ or other relevant social care qualification
                <div>
                  <span className="bluetext">
                    Assessed by Application Form,
                  </span>{" "}
                  <span className="blacktext">Needs -</span>{" "}
                  <span className="bluetext">Desirable</span>{" "}
                </div>
              </li>
            </ol>
          </div>
          <div className="jobdescsegment2heading pt-3">Other</div>
          <div className="jobdescsegment2list pt-2">
            <ol>
              <li>
                {" "}
                Warm, respectful and positive approach when working with service
                users
                <div>
                  <span className="bluetext">Assessed by Interview,</span>{" "}
                  <span className="blacktext">Needs -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                Willingness to work flexible hours according to needs of agency
                and service users{" "}
                <div>
                  <span className="bluetext">Assessed by Interview,</span>{" "}
                  <span className="blacktext">Needs -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                Willingness to attend training courses and events
                <div>
                  <span className="bluetext">Assessed by Interview,</span>{" "}
                  <span className="blacktext">Needs -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                Willing to accept feedback and guidance and to be accountable to
                colleagues and managers
                <div>
                  <span className="bluetext">Assessed by Interview,</span>{" "}
                  <span className="blacktext">Needs -</span>{" "}
                  <span className="bluetext">Essential</span>{" "}
                </div>
              </li>
              <li>
                {" "}
                To have a clean driving licence and access to a car
                <div>
                  <span className="bluetext">
                    Assessed by Application Form,
                  </span>{" "}
                  <span className="blacktext">Needs -</span>{" "}
                  <span className="bluetext">Desirable</span>{" "}
                </div>
              </li>
            </ol>
          </div>
        </div>
      </div> */}
      <div className="px-5 pb-5 pt-md-3">
        <a
          href={applicationform}
          target="_blank"
          rel="noopener noreferrer"
          className="applicationlink"
        >
          <button className="testimonialbtn d-flex">
            <span className="pe-2">Apply </span>{" "}
            <img
              src={uprightarrow}
              alt="arrow"
              className="homeSegment6testimoialarrow"
            />
          </button>
        </a>
      </div>
    </div>
  );
}
export default Jobdesc;
